export function defineReduxModule(definition) {
    return {
        ...definition,
        type: 'redux-module',
    };
}
